import React from 'react';

const AddFeaturedCouponsForm = () => {
  return (
    <div>
      Hi
    </div>
  );
};

export default AddFeaturedCouponsForm;
